module.exports = __webpack_public_path__ + "static/img/env05.a00d50b.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/env05.png
// module id = 100
// module chunks = 4